import { Box } from "@raca2022/uikit";
import styled from "styled-components";

export const Containner = styled(Box)`
  display: flex;
  align-items: center;
  padding: 5vw 4vw;
  flex-direction: column;
  background-color: #F2F9F9;
  h1 {
    margin-bottom: 32px;
    font-weight: 700;
    font-size: 50px;
    line-height: 110%;
    color: #144456;
    font-family: PoppinsBold;
  }
  p {
    font-family: PoppinsMedium;
    font-weight: 500;
    font-size: 24px;
    line-height: 110%;
    text-align: center;
    color: #8094ae;
    width: 100%;
    max-width: 1157px;
    margin-bottom: 16px;
  }
  @media only screen and (min-width: 1920px) {
    padding: 100px 80px 100px;
  }
  
  @media only screen and (max-width: 1024px) {
    h1{
      font-size: 3.73vw;
    }
    p{
      font-size: 2.8vw;
    }
  }
  @media only screen and (max-width: 428px) {
    h1{
      font-size: 16px;
    }
    p{
      font-size: 12px;
    }
  }
`;

export const BoxGroup = styled(Box)`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 2.27%;
  margin-top: 90px;
  flex-wrap: wrap;
  div {
    width: 31.82%;
    padding: 2% 3%;
    background: #20665E;
    box-shadow: 0px 0px 25px rgba(55, 105, 54, 0.07);
    border-radius: 20px;
    align-self: stretch;
    h1{
        font-weight: 700;
        font-size: 70px;
        line-height: 110%;
        color: #009768;
        font-family: PoppinsBold;
        padding-bottom: 8px;
        width: 100%;
        border-bottom: 1px solid #8094AE;
        margin-bottom: 24px;
    }
    h2{
        font-weight: 600;
        font-size: 24px;
        line-height: 110%;
        color: #00E09A;
        font-family: PoppinsSemiBold;
        margin-bottom: 12px;
    }
    p{
        font-weight: 500;
        font-size: 18px;
        line-height: 110%;
        color: #F2F9F9;
        font-family: PoppinsMedium ;
        text-align: left;
    }
  }
  @media only screen and (max-width: 1024px) {
    margin-top: 6vw;
    flex-direction: column;
    div{
      width: 100%;
      margin-bottom: 20px;
      h1{
        font-size: 6.54vw;
      }
      h2{
        font-size: 3.27vw;
      }
      p{
        font-size: 2.8vw;
      }
    }
  }
  @media only screen and (max-width: 430px) {
    margin-top: 26px;
    flex-direction: column;
    div{
      width: 100%;
      margin-bottom: 20px;
      h1{
        font-size: 28px;
      }
      h2{
        font-size: 16px;
      }
      p{
        font-size: 12px;
      }
    }
  }
`;
